import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import defaultCss from './MetricField.css';
import { getCohortFieldAndPeriod } from '../../../metricsUtils';
import { formatMetricValue } from '../metricDisplayUtils';
import Tooltip from '../../../../components/molecules/Tooltip';
import { GalleryContext } from '../../../consts';

const MetricField = ({
    value,
    label,
    shortLabel,
    data,
    metricValue: metricValueProp,
    cohort = false,
    showColon = false,
    classNames,
    shortenConfig,
}) => {
    const { fieldsMetadata } = useContext(GalleryContext);

    const css = classNames || {
        field: defaultCss.field,
        label: defaultCss.label,
        value: defaultCss.value,
    };

    const metricValue = metricValueProp ?? data?.[value];

    let metricBaseName = value;

    if (cohort) {
        [metricBaseName] = getCohortFieldAndPeriod(value);
    }

    const { display_format: displayFormat = {} } = fieldsMetadata[metricBaseName] || {};

    const formattedValue = formatMetricValue(metricValue, displayFormat, { shortenConfig });
    const fullFormattedValue = formatMetricValue(metricValue, displayFormat, { shortenConfig, isFullNumber: true });
    return (
        <Tooltip key={value} title={`${label}: ${fullFormattedValue}`}>
            <div className={css.field}>
                <div className={css.label}>
                    {shortLabel || label}
                    {showColon && ':'}
                </div>
                <div className={css.value}>{formattedValue}</div>
            </div>
        </Tooltip>
    );
};

MetricField.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    shortLabel: PropTypes.string,
    data: PropTypes.object,
    metricValue: PropTypes.number,
    cohort: PropTypes.bool,
    showColon: PropTypes.bool,
    classNames: PropTypes.shape({
        field: PropTypes.string,
        label: PropTypes.string,
        value: PropTypes.string,
    }),
    shortenConfig: PropTypes.objectOf(PropTypes.string),
};

export default MetricField;
